<template>
    <div class="field">
        <label
            v-if="label"
            class="label is-small pr-3"
            :class="{
                'has-text-right': rightAligned,
            }"
        >
            {{ label }}
        </label>

        <div
            :class="{
                control: true,
                'is-expanded': expanded,
            }"
        >
            <div
                :class="{
                    select: true,
                    'is-small': true,
                    'is-danger': hasErrors,
                    'is-fullwidth': expanded,
                }"
            >
                <select
                    v-model="choice"
                    v-bind="$attrs"
                    :disabled="readonly"
                >
                    <option
                        v-for="year in choices"
                        :key="year"
                        :value="year"
                    >
                        {{ year }}
                    </option>
                </select>
            </div>
        </div>
        <p
            v-for="error in errors"
            :key="error"
            class="help is-danger"
        >
            {{ error }}
        </p>
    </div>
</template>

<script>
import Field from "../Field";

export default {
    name: "T3YearsChoicesField",
    extends: Field,
    props: {
        modelValue: {
            type: [Number],
            default: null,
        },
        initialYear: {
            type: Number,
            required: true,
        },
        lastYear: {
            type: Number,
            required: true,
        },
        label: {
            type: String,
            default: "Year",
        },
    },
    emits: ["update:model-value"],
    computed: {
        choice: {
            get() {
                return this.modelValue;
            },
            set(newval) {
                this.$emit("update:model-value", newval);
            },
        },
        choices() {
            const result = [];
            for (let i = this.initialYear; i <= this.lastYear; i++) {
                result.push(i);
            }
            return result;
        },
    },
};
</script>
